import { StoryblokComponent, storyblokEditable } from "@/lib/blocks";
import type { PageBlok, BlokProps } from "@/types";

const Page = ({ blok }: BlokProps<PageBlok>) => (
  <main {...storyblokEditable(blok)}>
    {blok.body && blok.body.length > 0
      ? blok.body.map((nestedBlok) => (
          <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
        ))
      : null}
  </main>
);

export default Page;
